/**
 * True for HTTP(S) repository URLs and common Git remote forms used with
 * `git clone` (scp-style `git@host:path` and `ssh://...`). Align backend
 * validators with this set if SSH remotes must be accepted server-side.
 */
export function isRepositoryRemoteRef(value: string): boolean {
  const v = value.trim();
  if (!v) {
    return false;
  }

  if (/^ssh:\/\//i.test(v)) {
    try {
      new URL(v);
      return true;
    } catch {
      return false;
    }
  }

  if (/^git@[^\s:]+:\S+/i.test(v)) {
    return true;
  }

  try {
    const u = new URL(v);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

export function repositoryUrlIsWebLink(value: string): boolean {
  try {
    const u = new URL(value.trim());
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}
